import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import { SpecialtyViewModel, SpecialtyCreateCommand, SpecialtyUpdateCommand } from '../../../models/Entities/Specialties/SpecialtyModels';
import * as SpecialtiesStore from '../../../redux/middleware/Specialties.Middleware';

export interface IProps {
  isOpen: boolean;
  openPanel: () => void;
  dismissPanel: () => void;
  specialtyId?: number;
}

interface ConnectedProps {
  isAdding: boolean | undefined;
  successAdding: boolean | undefined;
  failAdding: boolean | undefined;
  isUpdating: boolean | undefined;
  successUpdating: boolean | undefined;
  failUpdating: boolean | undefined;
  error: ErrorType | undefined;
  specialty?: SpecialtyViewModel;
}

interface DispatchProps {
  CreateSpecialty: typeof SpecialtiesStore.actionCreators.CreateSpecialty;
  UpdateSpecialty: typeof SpecialtiesStore.actionCreators.UpdateSpecialty;
  GetAllSpecialties: typeof SpecialtiesStore.actionCreators.GetAllSpecialties;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isAdding: state.Specialties?.isAddingNewOne,
  successAdding: state.Specialties?.successAddingNewOne,
  failAdding: state.Specialties?.failOnAddingNewOne,
  isUpdating: state.Specialties?.isUpdatingOne,
  successUpdating: state.Specialties?.successUpdatingOne,
  failUpdating: state.Specialties?.failOnUpdatingOne,
  error: state.Specialties?.error,
  specialty: state.Specialties?.list.find((s) => s.id === ownProps.specialtyId),
  ...ownProps
});

export const mapDispatchToProps = {
  ...SpecialtiesStore.actionCreators
};
